import { atom } from "jotai";
import { NodeProps } from "@xyflow/react";
import type { CopilotUserMessage } from "../types";
import { nodeAtomFamily } from "./nodeAtomFamily";

export const askCopilotForNodeSuggestionSetter = atom(
  null,
  async (get, set, sourceNodeId: NodeProps["id"]) => {
    const sourceNode = get(nodeAtomFamily(sourceNodeId));
    if (!sourceNode) {
      return;
    }

    const workflowStep =
      "label" in sourceNode.data && sourceNode.data.label
        ? sourceNode.data.label
        : sourceNode.type;

    try {
      const message: CopilotUserMessage = {
        type: "COPILOT_USER_MESSAGE",
        payload: {
          message: `Based on my current workflow step "${workflowStep}", suggest what to add next to my system`,
          messageType: "text",
          source: "suggest-node-action",
        },
      };
      window.postMessage(message, "*");
    } catch (error) {
      console.error("Failed to send message to copilot:", error);
    }
  },
);

askCopilotForNodeSuggestionSetter.debugLabel =
  "askCopilotForNodeSuggestionSetter";
